import { environment } from './../../../../../../environments/environment.prod';
import { ExportInterfaceConfigurationRESTAuthType } from './../../../../../base/models/models.swagger.generated';
import { ImportConfigurationEditFormsCoordinatorService } from '../import-configuration-edit-forms-coordinator.service';
import { ImportConfigurationRestFormType } from './configuration-form-rest-form-type';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AppErrorMessagesComponent } from '../../../../../base/error-messages/app-error-messages.component';
import { TooltipModule } from '@syncfusion/ej2-angular-popups';

import { ButtonGroupComponent } from '../../../../../base/shared/button-group/button-group.component';

@Component({
    selector: 'app-configuration-form-rest',
    templateUrl: './configuration-form-rest.component.html',
    styleUrls: ['./configuration-form-rest.component.scss'],
    imports: [ReactiveFormsModule, ButtonGroupComponent, TooltipModule, AppErrorMessagesComponent, TranslateModule]
})
export class ConfigurationFormRestComponent implements OnInit {

  public get configurationFormRest(): FormGroup<ImportConfigurationRestFormType> {
    return this.formsCoordinationService.configurationFormRest;
  }

  public apiServerUrl = environment.apiServerUrl;

  ExportInterfaceConfigurationRESTAuthType = ExportInterfaceConfigurationRESTAuthType;

  constructor(
    public formsCoordinationService: ImportConfigurationEditFormsCoordinatorService,
  ) { }

  ngOnInit() {
    this.configurationFormRest.controls.restAccessType.valueChanges.subscribe(() =>{
      this.formsCoordinationService.setValidatorsForRestConfigForm();
      this.formsCoordinationService.setValidatorsForGeneralConfigForm();
    });
  }
}
